import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ThinArrowLeftIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.5 6.5L9 12L14.5 17.5" stroke="currentColor"/>
    </svg>

)
const ThinArrowLeftIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ThinArrowLeftIconSvg}
    </SvgIcon>
);
export default ThinArrowLeftIcon
